import { Outlet, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const FloatingHeader = lazy(() => import('src/components/Header/FloatingHeader'));
const MainFooter = lazy(() => import('src/components/MainFooter/MainFooter'));
const CallToActionBanner = lazy(
  () => import('src/components/CallToActionBanner/CallToActionBanner.tsx'),
);
const MiniPTFooterPromo = lazy(
  () => import('src/components/MiniPTFooterPromo/MiniPTFooterPromo.tsx'),
);
const ConsentBanner = lazy(() => import('src/components/ConsentBanner/ConsentBanner'));
import * as styles from './UtilityLayout.module.css';
import { uiStore } from 'src/store/uiStore.ts';
import { useScrollSmoother } from 'src/hooks/useScrollSmoother';

// Hook
import useRouteClass from 'src/hooks/useRouteClass';
import { REQUIRE_ANALYTICS_CONSENT } from 'src/config/constants.ts';

const UtilityLayout = () => {
  const location = useLocation();

  // Disable smooth scrolling only on the /trainer route
  // but keep it enabled for /onboarding-trainer
  const isTrainerRoute =
    location.pathname === '/trainer' ||
    location.pathname.startsWith('/trainer/') ||
    location.pathname === '/onboarding-trainer' ||
    location.pathname.startsWith('/onboarding-trainer/');

  useScrollSmoother({
    contentClass: 'smootherContent',
    enabled: !isTrainerRoute,
  });

  const setWaitlistModalVisible = uiStore((s) => s.setWaitlistModalVisible);
  const setQuizModalVisible = uiStore((s) => s.setQuizModalVisible);
  const setWaitlistEmail = uiStore((s) => s.setWaitlistEmail);

  useRouteClass();

  // Hide header and footers on specific standalone pages
  const isAuthPage =
    location.pathname.includes('/login') ||
    location.pathname.includes('/signup') ||
    location.pathname.includes('/dashboard') ||
    location.pathname.includes('/forgot-password') ||
    location.pathname.includes('/reset-password');

  return (
    <>
      {!isAuthPage && (
        <Suspense fallback={null}>
          <FloatingHeader />
        </Suspense>
      )}
      <div id="smooth-wrapper">
        <div className="smootherContent" id="smooth-content">
          <Outlet />
          {!isAuthPage && (
            <Suspense fallback={null}>
              <CallToActionBanner
                className={styles.callToAction}
                onPressJoinTheWaitlist={(email) => {
                  setWaitlistEmail(email || null);
                  setWaitlistModalVisible(true);
                }}
              />
              <MiniPTFooterPromo
                className={styles.promotionCard}
                onPressTakeFreeQuiz={() => {
                  setQuizModalVisible(true);
                }}
              />
              <MainFooter
                onPressTakeFreeQuiz={() => {
                  setQuizModalVisible(true);
                }}
              />
            </Suspense>
          )}
        </div>
      </div>
      {REQUIRE_ANALYTICS_CONSENT && (
        <Suspense fallback={null}>
          <ConsentBanner />
        </Suspense>
      )}
    </>
  );
};

export default UtilityLayout;
